<template>
  <BaseModal modal-content-class="resub">
    <div class="content">
      <h1>{{ $_translations.value.modal_resubscribe_success_title }}</h1>

      <AvatarImage
        :src="authStore.userAvatar"
        image-class="top_img re_subscribe_user"
      />

      <div class="user_name">{{ authStore.userUsername }}</div>

      <p>{{ $_translations.value.modal_resubscribe_success_subtitle }}</p>

      <p>{{ $_translations.value.modal_resubscribe_success_description }}</p>

      <BaseButton
        container-class="resub_btn"
        @click:button="$emit('proceed:successResubscribe')"
      >
        {{ $_translations.value.modal_resubscribe_success_button_proceed }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import AvatarImage from '@/components/image/AvatarImage.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import useAuthStore from '@/store/modules/auth.js';

defineEmits(['proceed:successResubscribe']);

const authStore = useAuthStore();
</script>
